import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { map } from 'rxjs/operators';
import { EnumSolicitacaoCompraFornecedorStatus } from 'src/app/enum-types/enum-solicitacao-compra-fornecedor-status';
import { EnumSolicitacaoCompraTipoFrete } from 'src/app/enum-types/enum-solicitacao-compra-tipo-frete';
import { Cliente } from '../cadastro/cliente';
import { ClienteService } from '../cadastro/service/cliente.service';
import { DialogComponent } from '../dialog/dialog.component';
import { EnumStatusCotacao } from '../enum-types/enum-status-cotacao';
import { JwtService } from '../jwt.service';
import { SolicitacaoCompraFornecedor } from '../persistences/solicitacao-compra-fornecedor';
import { Configuracoes } from '../services/configuracoes.service';
import { CotacaoService } from '../services/cotacao.service';
import { CORE_IMPORTS } from '../providers/module-providers';

@Component({
  standalone: true,
  selector: 'app-lista-cotacoes',
  templateUrl: './lista-cotacoes.component.html',
  styleUrls: ['./lista-cotacoes.component.css'],
  imports: [CORE_IMPORTS]
})
export class ListaCotacoesComponent implements OnInit {

  cotacoes: Array<SolicitacaoCompraFornecedor>;
	@ViewChild('myInputFile')
	myInput: ElementRef;
	SolicitacaoCompraTipoFrete = EnumSolicitacaoCompraTipoFrete;
	constructor(private cotacaoService: CotacaoService,
		public router: Router,
		public snackBar: MatSnackBar,
		public dialog: MatDialog,
		private jwtService: JwtService,
	) { }

	ngOnInit() {
		this.jwtService.validarAcessToken();
		this.load();		
	}

	getIdsCotacoes(): Array<string> {
		const ids: Array<string> = [];
		for (const cotacao of this.cotacoes) {
			ids.push(cotacao.idGeral);
		}
		return ids;
	}

	load() {
		this.cotacaoService.getSolicitacoes().pipe(
			map((val: SolicitacaoCompraFornecedor[]) =>
				val.sort((a, b) => {
					let diff = this.getStatusCotacao(b) - this.getStatusCotacao(a)
					if (diff == 0) {
						diff = b.solicitacaoCompra.nrSolicitacao - a.solicitacaoCompra.nrSolicitacao;
					}
					return diff;
				})
			)).subscribe((val: SolicitacaoCompraFornecedor[]) => {
				this.cotacoes = val, (e: Response) => console.log(e.text());
			}, (e: Response) => {
				this.jwtService.dialogMensagemSessaoExpirada();
			}
		);	
	}

	getIcon(cot: SolicitacaoCompraFornecedor): string {
		switch (this.getStatusCotacao(cot)) {
			case EnumStatusCotacao.FECHADA:
				return "check_circle";
			case EnumStatusCotacao.PARCIAL:
				return "error";
			case EnumStatusCotacao.ABERTA:
				return "new_releases";
		}
	}

	getIconColor(cot: SolicitacaoCompraFornecedor): string {
		switch (this.getStatusCotacao(cot)) {
			case EnumStatusCotacao.FECHADA:
				return "#18834d";
			case EnumStatusCotacao.PARCIAL:
				return "#ffe364";
			case EnumStatusCotacao.ABERTA:
				return "#2e3363";
		}
	}

	getStatusCotacao(cot: SolicitacaoCompraFornecedor): EnumStatusCotacao {
		if (cot.flStatus == EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO][0]) {
			return EnumStatusCotacao.FECHADA;
		}
		for (let i = 0; i != cot.solicitacaoCompraItemCotacoes.length; i++) {
			const it = cot.solicitacaoCompraItemCotacoes[i];
			if (it.vlBruto != 0) {
				return EnumStatusCotacao.PARCIAL;
			}
		}
		return EnumStatusCotacao.ABERTA;
	}

	getXls(cotacao: SolicitacaoCompraFornecedor) {		
		this.cotacaoService.getXls(cotacao.solicitacaoCompra.cdFilial, cotacao.solicitacaoCompra.nrSolicitacao);
	}

	onFileChanged(event, cdFilial: number, nrSolicitacao: number) {
		if (event.target.files.length > 1) {
			this.myInput.nativeElement.value = "";
			return alert("Escolha apenas um item");
		}
		const selectedFile = event.target.files[0];
		const readerUrl = new FileReader();

		readerUrl.onload = () => {
			this.cotacaoService.postXls(readerUrl.result.toString(), cdFilial, nrSolicitacao).subscribe(() => {
				this.router.navigate([`/cotacao/${cdFilial}/${nrSolicitacao}`]);
			}, (error: any) => {
				if (error.status >= 500) {
					this.myInput.nativeElement.value = "";
					let response = "Erro ao processar dados.";
					response += " Certifique-se de ter enviado um arquivo '.xls'.\n Arquivo enviado: "+selectedFile.name;
					this.chamaDialog(response);
				}
				else {
					if(error.error.text instanceof SyntaxError){
						this.chamaDialog(error.error.text);
					} else{
						this.chamaDialog(error.error.split(':').slice(1).join(':'));
						this.ngOnInit();
					}
				}
			})
		}

		readerUrl.readAsDataURL(selectedFile);
	}

	chamaDialog(erro: string) {
		const dialogRef = this.dialog.open(
			DialogComponent, {
			width: "400px",
			height: "400px",
			panelClass: 'custom-dialog',
			data: { error: erro }
		}
		);
		dialogRef.afterClosed().subscribe(
			result => {
				if(result != undefined){
					if (result) {
						console.log("BELEZURA");
					} else {
						console.log(result);
						console.log(result["status"]["messagem"]);
					}
				}
			}
		);
	}

	logout() {
		this.jwtService.logout();
	}

}